import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Process from "@/pages/Process";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("lenis", "lenis-smooth");
    const enforceTitle = setInterval(() => {
      const desired = window.__desiredTitle || "Kotam Projects | Premium Builders";
      if (document.title !== desired) document.title = desired;
    }, 800);
    return () => {
      clearInterval(enforceTitle);
      document.documentElement.classList.remove("lenis", "lenis-smooth");
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/process" element={<Process />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
